import { useRequiredContext } from "@redotech/react-util/context";
import AiStarIcon from "@redotech/redo-icons/ai-star.svg";
import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { useRpcQuery } from "@redotech/redo-web/rpc-query/use-rpc-query";
import { memo } from "react";
import { matchPath, useLocation } from "react-router-dom";

export const MarketingAgentItems = memo(function MarketingAgentItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const location = useLocation();

  const isEnabled = team.settings.marketing?.marketingAgent?.enabled ?? false;

  const { data: splitInfo, isLoading } = useRpcQuery(
    RedoMarketingRpcClientContext,
    {
      method: "getMarketingAgentSplitInfo",
      args: {},
      options: { enabled: isEnabled },
    },
  );

  const testIsRunning = !isLoading && (splitInfo?.isActive ?? false);

  const marketingAgentBaseUrl = routes.marketingAgentHref;
  const anyChildSelected = !!matchPath(
    `${marketingAgentBaseUrl}/*`,
    location.pathname,
  );

  return (
    <>
      {/* Simple flat item when test is NOT running - links to setup page */}
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.marketingAgentHref }}
        FilledIcon={AiStarIcon}
        friendlyName="Marketing Agent"
        hidden={!isEnabled || testIsRunning}
        id="marketing-agent-setup"
        UnfilledIcon={AiStarIcon}
      />
      {/* Dropdown with children when test IS running */}
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getMarketingAgentSubRoute("dashboard"),
        }}
        anyChildSelected={anyChildSelected}
        FilledIcon={AiStarIcon}
        friendlyName="Marketing Agent"
        hidden={!isEnabled || !testIsRunning}
        id="marketing-agent"
        UnfilledIcon={AiStarIcon}
      >
        <RedoSecondaryNavItem
          action={{
            type: "link",
            href: routes.getMarketingAgentSubRoute("dashboard"),
          }}
          friendlyName="Dashboard"
          id="marketing-agent-dashboard"
        />
        <RedoSecondaryNavItem
          action={{
            type: "link",
            href: routes.getMarketingAgentSubRoute("analytics"),
          }}
          friendlyName="Analytics"
          id="marketing-agent-analytics"
        />
        <RedoSecondaryNavItem
          action={{
            type: "link",
            href: routes.getMarketingAgentSubRoute("conversations"),
          }}
          friendlyName="Conversations"
          id="marketing-agent-conversations"
        />
      </RedoSecondaryNavItem>
    </>
  );
});
